import { Button, MainArea, Page } from '@salecycle/ui-component-library';
import React, { FC } from 'react';
import { connect } from 'react-redux';
import { Actions as RouterActions, Selectors as RouterSelectors } from 'router';
import { State } from 'store';
import AppTopBar from '../../../../core/ui/components/AppTopBar/AppTopBar';

export interface OwnProps {
  header?: JSX.Element;
  children?: React.ReactNode;
}

export interface StateProps extends OwnProps {
  siteId: string;
}

interface DispatchProps {
  push: (href: string) => void;
}

export type Props = StateProps & DispatchProps;

export const PageWrapper: FC<Props> = props => {
  const newCampaign = () => props.push(`/sites/${props.siteId}/campaigns/campaigns/newcampaign/objective`);
  return (
    <MainArea>
      {props.header ? (
        props.header
      ) : (
        <AppTopBar>
          <Button variation="secondary" onClick={newCampaign}>
            New Campaign
          </Button>
        </AppTopBar>
      )}
      <Page>{props.children}</Page>
    </MainArea>
  );
};

const mapState = (state: State, ownProps: OwnProps): StateProps => {
  return {
    ...ownProps,
    siteId: RouterSelectors.getSiteId(state),
  };
};

const actions: DispatchProps = {
  push: RouterActions.push,
};

export default connect(mapState, actions)(PageWrapper);
